import React from 'react';
import { Drawer, List, Hidden, ListItem, ListItemIcon, ListItemText, AppBar, Toolbar, IconButton, Typography, Button } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import { withStyles } from '@material-ui/core/styles';
import { Add, CameraEnhance, AccountCircle } from '@material-ui/icons';
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from 'react-router-dom';
import { Context } from '../../Context';
import { CreateCampaign } from '../CreateCampaign';
import './styles.css'

const drawerWidth = 256;

const styles = (theme) => ({
	root: {
		display: 'flex',
	},
	drawer: {
		[theme.breakpoints.up('sm')]: {
			width: drawerWidth,
			flexShrink: 0,
		}
	},
	appBar: {
		marginLeft: drawerWidth,
		zIndex: theme.zIndex.drawer + 1
	},
	menuButton: {
		marginRight: 20,
		[theme.breakpoints.up('sm')]: {
			display: 'none'
		}
	},
	toolbar: theme.mixins.toolbar,
	drawerPaper: {
		width: drawerWidth
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing.unit * 3
	},
	fab: {
		// margin: theme.spacing.unit,
	},
	addIcon: {
		marginRight: theme.spacing.unit,
	},
});

class VimmaDrawer extends React.Component {
	state = {
		mobileOpen: false,
		selectedIndex: 1,
		newCampaignDialogOpen: false,
		showMobile: true
	};

	handleDrawerToggle = () => {
		this.setState(state => ({ mobileOpen: !state.mobileOpen }));
	};

	handleListItemClick = (event, index) => {
		this.setState({ selectedIndex: index, mobileOpen: false });
	};

	handleDialogClose = () => {
		this.setState(state => ({ newCampaignDialogOpen: false }));
	};

	handleDialogOpen = (shouldShowMobile) => {
		this.setState(state => ({ newCampaignDialogOpen: true, mobileOpen: false, showMobile: !!shouldShowMobile }));
	};

	render() {
		const { classes } = this.props;

		const drawer = (
			<div>
				<div className="mobile-padding-toolbar">
					<div className={classes.toolbar} />
				</div>
				<List>
					<ListItem className="desktop" >
						<div style={{ paddingLeft: '16px' }}>
							<Fab variant="extended" onClick={event => this.handleDialogOpen(false)} color="primary" aria-label="New campaign" className={classes.fab}>
								<Add className={classes.addIcon} />
								New Campaign
      					</Fab>
						</div>
					</ListItem>
					<ListItem className="mobile" >
						<div style={{ paddingLeft: '16px'  }}>

							<Fab className="mobile" variant="extended" onClick={event => this.handleDialogOpen(true)} color="primary" aria-label="New campaign" className={classes.fab}>
								<Add className={classes.addIcon} />
								New Campaign
      					</Fab>
						</div>
					</ListItem>
					<ListItem button key='Campaigns' selected={this.state.selectedIndex === 1} onClick={event => this.handleListItemClick(event, 1)} component={Link} to='/'>
						<ListItemIcon>
							<CameraEnhance />
						</ListItemIcon>
						<ListItemText primary='Campaigns' />
					</ListItem>
					<ListItem button key='Account' selected={this.state.selectedIndex === 2} onClick={event => this.handleListItemClick(event, 2)} component={Link} to='/account'>
						<ListItemIcon>
							<AccountCircle />
						</ListItemIcon>
						<ListItemText primary='My Account' />
					</ListItem>
				</List>
			</div>
		);

		return (
			<div className={classes.root}>
				<CreateCampaign showMobile={this.state.showMobile} open={this.state.newCampaignDialogOpen} handleDialogClose={this.handleDialogClose} />
				<AppBar position="fixed" className={classes.appBar}>
					<Toolbar>
						<IconButton
							color="inherit"
							aria-label="Open drawer"
							onClick={this.handleDrawerToggle}
							className={classes.menuButton}
						>
							<MenuIcon />
						</IconButton>
						<Typography variant="h6" color="inherit" noWrap style={{ flexGrow: 1 }}>
							{this.state.selectedIndex === 2 ? 'My account' : 'Campaigns'}
						</Typography>
						<a href='https://www.vimma.ai' target='_blank' rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'inherit' }}><Button color='inherit'>Help</Button></a>
					</Toolbar>
				</AppBar>
				<nav className={classes.drawer}>
					<Hidden smUp implementation="css">
						<Drawer
							container={this.props.container}
							variant="temporary"
							open={this.state.mobileOpen}
							onClose={this.handleDrawerToggle}
							classes={{
								paper: classes.drawerPaper
							}}
							ModalProps={{
								keepMounted: true
							}}
						>
							{drawer}
						</Drawer>
					</Hidden>
					<Hidden xsDown implementation="css">
						<Drawer
							classes={{
								paper: classes.drawerPaper
							}}
							variant="permanent"
							open
						>
							{drawer}
						</Drawer>
					</Hidden>
				</nav>
			</div >
		);
	}

};
VimmaDrawer.contextType = Context;
export default withStyles(styles)(VimmaDrawer);
